import GenericInformationTable, { TableRow } from "components/ui/table/GenericInformationTable";
import { CapacityLeadState } from "../types/enums";

interface Props {
  firstName: string;
  lastName: string;
  productName: string;
  clientAvailability: string;
  requestZipCode: string;
  requestRegion: string;
  phoneNumber: string;
  capacityLeadState: CapacityLeadState;
}

/**
 * CapacityLeadBasicInformationTable displays key lead information using the GenericInformationTable.
 * It builds an array of table rows for fields such as the client's name, phone number, product need,
 * requested region, and best availability.
 */
function CapacityLeadBasicInformationTable({
  firstName,
  lastName,
  productName,
  clientAvailability,
  requestRegion,
  requestZipCode,
  phoneNumber,
}: Readonly<Props>) {

  // Determine the title for the client name field.
  function getClientNameTitle(): string {
    if (firstName && lastName) {
      return "Name, Vorname:";
    } else if (firstName && firstName.trim() !== "") {
      return "Vorname:";
    } else if (lastName && lastName.trim() !== "") {
      return "Name:";
    }

    return "Name, Vorname:";
  }

  // Return the client name (or a placeholder when not allowed).
  function getClientName(): string {
    return firstName && lastName
      ? `${lastName}, ${firstName}`
      : firstName || lastName || "N/A";
  }

  const rows: TableRow[] = [
    {
      fieldName: getClientNameTitle(),
      value: getClientName(),
    },
    {
      fieldName: "Telefonnummer:",
      value: phoneNumber,
    },
    {
      fieldName: "Bedarf:",
      value: productName,
    },
    {
      fieldName: "Bedarfsort:",
      value: `${requestRegion}, ${requestZipCode}`,
    },
    {
      fieldName: "Beste Erreichbarkeit:",
      value: clientAvailability,
    },
  ];

  return (
    <div>
      <h3 className="text-blue">Rufen Sie jetzt an:</h3>
      <GenericInformationTable title="Die wichtigsten Daten auf einen Blick" rows={rows} />
    </div>
  );
}

export default CapacityLeadBasicInformationTable;
